import axios from "axios";
import {
	Setitem,
	Getitem
} from "./item.js";
import store from "../store";

// 初始化HEADER
const HEADER = {
	'ClientId': "mp_cus",
};

const service = axios.create({
	baseURL: "https://1song.run/songsong/",
	timeout: 10000,
	headers: HEADER,
});

service.interceptors.request.use(
	(config) => {
		const token = Getitem("user");
		if (token) {
			config.headers.token = token;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

service.interceptors.response.use(
	(response) => {
		const res = response.data;

		if (res.code === 401) {
			handle401();
		}
		return response;
	},
	(error) => {
		if (error.response && error.response.status === 401) {
			handle401();
		}
		return Promise.reject(error);
	}
);

async function handle401() {
	Setitem("user", "");
	Setitem("name", "");
	store.commit('setusername', '');
	store.commit('setlog401', '401')
	try {
		const loginRes = await templogin();
		console.log("自动登录结果:", loginRes);
	} catch (error) {
		console.error("自动登录失败:", error);
	}
}
// -----------------------------查询工人--------------------------
export const worker = async (data) => {
	try {
		const response = await service({
			url: `worker/mp/list`,
			method: "GET",
			params: data,
		});
		const res = response.data;
		if (res.code === 200) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};
// -----------------------------查询所有工种和服务--------------------------
export const workall = async (data) => {
	try {
		const response = await service({
			url: `worktype/mp/all/ver`,
			method: "GET",
			params: {
				data
			},

		});
		const res = response.data;
		if (res.code === 200) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};
// -----------------------------验证身份证--------------------------
export const iscard = async (name, idNum) => {
	try {
		const response = await service({
			url: `login/mp/check`,
			method: "POST",
			data: {
				name,
				idNum
			},

		});
		const res = response.data;
		if (res.code === 200) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};

// ----------------------------注册获取验证码-------------------------
export const phonecode = async (phone) => {
	try {
		const response = await service({
			url: `login/mp/login/code?`,
			method: "GET",
			params: {
				phone
			},

		});
		const res = response.data;
		if (res.code === 200) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};
// -------------------------验证码验证--------------------------
export const codecheck = async (phone, code) => {
	try {
		const response = await service({
			url: `login/mp/register/code/check`,
			method: "GET",
			data: {
				phone,
				code
			},

		});
		const res = response.data;
		if (res.code === 200) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};
// -------------------------会员期限-------------------------
export const cost = async () => {
	try {
		const response = await service({
			url: `worker/mp/member/cost`,
			method: "GET",

		});
		const res = response.data;
		if (res.code === 200) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};
// -------------------------会员提交-------------------------
export const worksave = async (data) => {
	try {
		const response = await service({
			url: `worker/mp/save`,
			method: "POST",
			data

		});
		const res = response.data;
		if (res.code === 200) {
			return res;
		} else {
			return res;
		}
	} catch (error) {
		throw error;
	}
};